import { Link } from 'react-router-dom';

export default function PaymentFail() {
  return (
    <div className="page container">
      <h1>Оплата не прошла</h1>
      <p><Link to="/cart">Вернуться в корзину</Link></p>
    </div>
  );
}
